import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0078',
    ecrans: ['00-2']
});
